export default {
  en: "English",
  fr: "Français"
}
